import * as React from 'react';
/**
 *
 * Original name: Automatic Computer Backup
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=4411%3A55
 *
 */
export const AutomaticComputerBackupSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M19 30.063h82v7.5h6v-13.5H13v48.75c0 6.213 5.037 11.25 11.25 11.25H57V95H42v6h36v-6H63V84.062h32.75c6.213 0 11.25-5.036 11.25-11.25v-14.26l6.692 6.693 4.243-4.242-13.91-13.91-13.91 13.91 4.243 4.242L101 58.603v14.21a5.25 5.25 0 0 1-5.25 5.25h-71.5a5.25 5.25 0 0 1-5.25-5.25v-42.75Z", fill: "currentColor" })));
